import initMenu from "./modules/menu";
import './modules/hash';
import './modules/fancybox';
import initSelects from './modules/selects';
import './modules/accordion';
import './modules/testimonials-masonry-listing';
import './modules/portfolio-isotope-listing';
import './modules/fancybox';
import './modules/swipers';
import './modules/file-input';
import './modules/team';
import './modules/phases';
import './modules/twentytwenty';
import './modules/gallery-simple-listing';
import './modules/gallery-masonry-listing';
import './modules/gallery-isotope-listing';
import './modules/project-gallery-masonry-listing';
import './modules/location-google-map';
import './modules/blog-simple-listing';
import smoothscroll from 'smoothscroll-polyfill';

import '../scss/theme.scss';

jQuery(document).ready( function($) {
    smoothscroll.polyfill();
    initMenu();
    initSelects();
});


document.addEventListener('DOMContentLoaded', function () {
    var titleField = document.getElementById('page-title');
    if (titleField) {
        titleField.value = document.querySelector('.hero__title').innerText;
    }
});